import { useIntersect, useScroll, Image, useTexture, shaderMaterial, Text, Instances, Instance, createInstances, InstancedAttribute, Float, Html, Sparkles, OrthographicCamera, useVideoTexture } from "@react-three/drei"
import { mainStore } from "../../store"
import { extend, useFrame, useThree } from "@react-three/fiber"
import waveVertexShader from '../../shaders/wave/vertex.glsl'
import waveFragmentShader from '../../shaders/wave/fragment.glsl'
// import { BatchedWaveMaterial } from '../../utils.js'
import { Suspense, useEffect, useMemo, useRef } from "react"
import { __ } from "../../utils"
import * as THREE from 'three'
import { Tensine } from "../../components/models/tensine/model.jsx"
import TextExposant from "../../components/textExposant.jsx"
import Amanduline from "../../components/image/Amanduline.jsx"
import AtelierProduction from "../../components/image/AtelierProduction.jsx"
import Team from "../../components/team.jsx"
import Levures from "../../components/models/levure/island.jsx"

import TextRight from "../../components/textRight.jsx"
import TextLeft from "../../components/textLeft.jsx"
import TextCenter from "../../components/textCenter.jsx"
import TestVivo from "../../components/image/TestVivo.jsx"
import VideoPlane from "../../components/videoPlane.jsx"

export default function BodyChapterTwo() {
    // Utils
    const data = useScroll()
    const [EpiInstances, Epi] = createInstances()
    const { width, height } = useThree((state) => state.viewport)


    // Store
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)
    const scrollMap = mainStore.useStore(s => s.scrollMap)
    const currentChapter = mainStore.useStore((s) => s.current)
    const isUiHidden = mainStore.useStore((s) => s.isUiHidden)
    const preventChapterUpdate = mainStore.useStore(s => s.preventChapterUpdate)
    const chapterChangeRequested = mainStore.useStore(s => s.current.chapterChangeRequested)

    const lang = mainStore.useStore(s => s.lang)


    
    const chapters = mainStore.useStore(s => s.chapters)
    const chapter = chapters[1]


    // Refs
    const refs = useRef([])
    const citationRef = useRef()
    const episRef = useRef()
    const vegetalTextRef = useRef()
    const episFirstParagraphRef = useRef()
    const episSecondParagraphRef = useRef()
    const tensineRef = useRef()

    const episOpacity = {}

    const assignOpacityEpis = (ref) => {
        episOpacity[ref] = refs.current[ref].opacity
    }

    /**
     * Shaders
     * */

    const textures = [
        useTexture(import.meta.env.BASE_URL + 'static/epi-texture-one.webp'),
        useTexture(import.meta.env.BASE_URL + 'static/epi-texture-two.webp')
    ]
    const WaveShaderMaterialOne = shaderMaterial(
        {
            color: /* @__PURE__ */ new THREE.Color('white'),
            scale: /* @__PURE__ */ new THREE.Vector2(1, 1),
            imageBounds: /* @__PURE__ */ new THREE.Vector2(1, 1),
            resolution: 512,
            zoom: 1,
            radius: 0,
            grayscale: 0,
            opacity: 1,
            map: textures[0],
            uTime: { value: 0 },
            uOffset: { value: 0 }
        },
        waveVertexShader,
        waveFragmentShader,
    )

    const WaveShaderMaterialTwo = shaderMaterial(
        {
            color: /* @__PURE__ */ new THREE.Color('white'),
            scale: /* @__PURE__ */ new THREE.Vector2(1, 1),
            imageBounds: /* @__PURE__ */ new THREE.Vector2(1, 1),
            resolution: 512,
            zoom: 1,
            radius: 0,
            grayscale: 0,
            opacity: 1,
            map: textures[1],
            uTime: { value: 0 },
            uOffset: { value: 0 }
        },
        waveVertexShader,
        waveFragmentShader,
    )

    extend({ WaveShaderMaterialOne, WaveShaderMaterialTwo })

    for (const ref in refs.current) {
        refs.current[ref].needsUpdate = true
        // assignOpacityEpis(ref)
    }

    let range = 1

    useFrame(({ clock }) => {

        // Handle wheatfield ref & disapear
        if (refs.current) {
            for (const ref in refs.current) {
                refs.current[ref].uTime = clock.getElapsedTime()
                if (typeof episOpacity[ref] === "number") {
                    range = Math.max(episOpacity[ref] - data.range(scrollMap.one + 0.255 * scrollMap.two, scrollMap.one + 0.33 * scrollMap.two) * 59, -1)
                    refs.current[ref].opacity = range
                } else {
                    // assignOpacityEpis(ref)
                }
            }
        }

        // Citation animation
        citationRef.current.position.y = Math.min(-3 + data.range(scrollMap.one + 0.180 * scrollMap.two, scrollMap.one + 0.30 * scrollMap.two) * 98, 4)

        // Title reveal & stand on plant era 
        vegetalTextRef.current.position.y = Math.min(-1 + data.range(scrollMap.one + 0.220 * scrollMap.two, scrollMap.one + 0.30 * scrollMap.two) * 89, 4)
        vegetalTextRef.current.fillOpacity = Math.min(0 + data.range(scrollMap.one + 0.220 * scrollMap.two, scrollMap.one + 0.30 * scrollMap.two) * 89, 1)
        vegetalTextRef.current.strokeOpacity = Math.min(0 + data.range(scrollMap.one + 0.221 * scrollMap.two, scrollMap.one + 0.30 * scrollMap.two) * 89, 4)

        // Parapgraph reveal plant era
        episFirstParagraphRef.current.fillOpacity = Math.min(0 + data.range(scrollMap.one + 0.230 * scrollMap.two, scrollMap.one + 0.3 * scrollMap.two) * 89, 1)
        episSecondParagraphRef.current.fillOpacity = Math.min(0 + data.range(scrollMap.one + 0.230 * scrollMap.two, scrollMap.one + 0.3 * scrollMap.two) * 89, 1)



        // Chapter auto selector
        // if (data.scroll.current > scrollMap.one && data.scroll.current <= scrollMap.two && !currentChapter.dates.includes(1991) && isUiHidden && !preventChapterUpdate) {
        //     mainStore.selectChapter('UNICITÉ', [1990, 1999])
        // }

        if (data.scroll.current > chapter.start && data.scroll.current <= scrollMap.two) {

            if(!currentChapter.dates.includes(1990) || !currentChapter.dates.includes(2000))
            {
                mainStore.preventChapterUpdate(true)
                mainStore.selectChapter(chapter.name[lang === 'fr' ? lang : 'en'], chapter.dates, chapter.start)
                setTimeout(() => mainStore.preventChapterUpdate(false), 1000)

            }
        }
    })

    const wheatField = useMemo(() => {
        return <group position={[0, 0, 0]} ref={episRef}>
            {[...Array(155)].map((value, index) =>
                <mesh
                    key={index}
                    scale={[0.5, 0.5 + Math.random() * 0.5, .5]}
                    position={[
                        (Math.random() - 0.25) * 6,
                        -1,
                        3.8 - index * 0.02
                    ]}
                    rotation={[0, 0, Math.PI * 0.1]}
                >
                    <planeGeometry />
                    {
                        (Math.round(Math.random() + 0.2)) ?
                            <waveShaderMaterialOne depthWrite={false} key={WaveShaderMaterialOne.key} opacity={1.0 - (index * 0.001615)} ref={(ref) => (refs.current[index] = ref)} uTime={0} uOffset={Math.random()} transparent toneMapped={false} zoom={0.7} />
                            :
                            <waveShaderMaterialTwo depthWrite={false} key={WaveShaderMaterialTwo.key} opacity={1.0 - (index * 0.001615)} ref={(ref) => (refs.current[index] = ref)} uTime={0} uOffset={Math.random()} transparent toneMapped={false} zoom={0.7} />
                    }
                </mesh>
            )}
        </group>
    }, [])



    return <>
        <group position={[0, -18.5, 0]}>
            <group position={[-2, -3, 0]}>
                <group ref={citationRef} position={[0, 0, -2]}>
                    <Text
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.299}
                        position={[0.5, 0, 1]}
                        font={fonts.cm.titleBold}
                        color={colors.title}
                        textAlign="left">«</Text>
                    <Text

                        maxWidth={3}
                        lineHeight={1.4}
                        fontSize={0.189}
                        position={[2.25, 0, 1]}
                        font={fonts.cm.legend}
                        color={colors.title}
                        textAlign="center"
                    >

                        {
                            __('Dans son infinie diversité, la Nature a déjà Tout prévu, Tout et le contraire de Tout.',
                                'In its infinite diversity, Nature has thought of everything, everything and the opposite of everything.'
                            )
                        }

                    </Text>
                    <Text
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.289}
                        position={[4, 0, 1]}
                        font={fonts.cm.titleBold}
                        color={colors.title}
                        textAlign="left">»</Text>
                    <Text
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.119}
                        position={[2.25, -0.6, 1]}
                        opacity={0.5}
                        font={fonts.cm.legend}
                        color={colors.title}
                        textAlign="center"
                    >
                        {
                            __('Jean PAUFIQUE', 'Jean Paufique')
                        }
                        
                    </Text>
                </group>

                <Suspense>
                    {wheatField}
                    {/* <Image
                     url={import.meta.env.BASE_URL + "static/aquarelle-texture.webp"} 
                     transparent
                     scale={[ 10, 5, 10]}
                     zoom={0.6}
                     segments={4}
                     position={[5,0, 3]}
                     rotation={[0, 0, Math.PI * 0.0]}
                     toneMapped={false}
                     color={ colors.clear }
                    /> */}
                    <Sparkles position={[2, -0.5, 2]} count={100} speed={0.1} color={'grey'} scale={[4, 0.5, 2]} opacity={0.5} />

                </Suspense>

                <group>
                    <Text
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.129}
                        position={[2.025, -0.6, 4.45]}
                        opacity={0.5}
                        fillOpacity={1}
                        strokeColor={colors.title}
                        strokeWidth={0.00001}
                        font={fonts.ms.title}
                        color={colors.title}
                        textAlign="center"
                        depthWrite={false}
                    >
                        1990
                    </Text>
                    <Text
                        ref={vegetalTextRef}
                        maxWidth={12}
                        lineHeight={1.4}
                        fontSize={0.8289}
                        position={[2.57, -0.5, -4.5]}
                        opacity={1}
                        fillOpacity={1}
                        strokeOpacity={1}
                        strokeColor={colors.secondary}
                        strokeWidth={0.0001}
                        font={fonts.ms.title}
                        color={colors.title}
                        textAlign="center"
                        depthWrite={false}
                    >
                        {__('Début de l’ère végétale', 'Plant based era begins')}
                    </Text>

                    <Text
                        ref={episFirstParagraphRef}
                        maxWidth={1}
                        lineHeight={1.4}
                        fontSize={0.0489}
                        position={[2.07, -1.45, 3.5]}
                        opacity={0.5}
                        fillOpacity={1}
                        font={fonts.cm.title}
                        color={colors.title}
                        textAlign="center"
                        depthWrite={false}
                    >
                        {
                            __('SILAB est la première société à proposer des actifs d’origine végétale à l’industrie cosmétique.',
                                'SILAB is the first company to offer active ingredients of plant origin to the cosmetics industry.'
                            )
                        }

                    </Text>

                    <Text
                        ref={episSecondParagraphRef}
                        maxWidth={1.19}
                        lineHeight={1.9}
                        fontSize={0.0289}
                        position={[2.07, -1.7, 3.5]}
                        opacity={0.5}
                        fillOpacity={1}
                        font={fonts.ms.text}
                        color={colors.title}
                        textAlign="center"
                        depthWrite={false}
                    >
                        {
                            __(
                                'Dans un contexte de crises sanitaires liées au monde animal, Jean PAUFIQUE, visionnaire et agile, anticipe et transpose son savoir-faire au monde végétal, ce qui marque le succès de l’entreprise.',
                                'Against a backdrop of health crisis in the animal world, Jean Paufique, visionary and agile, anticipates and transposes his know-how to the plant world, marking the company\'s success.'
                            )
                        }

                    </Text>
                </group>
            </group>
            <group position={[0, -6, 0]}>
                <Amanduline position={[-3, -0.6, 1]} scale={1.2} />



                <group position={[0, 0, 0]}>
                    <TextRight
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.26}
                        positionY={0}
                        // positionX={-0.09}
                        // positionZ={1.2}
                        fontsOw={fonts.ms.title}
                    >
                        1991
                    </TextRight>
                    {
                        __(
                            // FR
                            <>
                                <TextRight maxWidth={2} fontsOw={fonts.cm.title} fontSize={0.16} positionY={-0.1} scale={1} exposant={"er"} offsetX={-1.6} offsetY={0.035}>
                                    1   actif cosmétique végétal
                                </TextRight>
                                <TextRight maxWidth={1.6} lineHeight={1.6} fontsOw={fonts.ms.text} exposantHeight={0.04} fontSize={0.062} positionY={-0.37} exposant={"®"} offsetX={-1.01} offsetY={-0.18}>
                                    TENSINE   , issu du blé, est le premier actif phytotenseur commercialisé par SILAB.
                                </TextRight>
                            </>
                            ,
                            // EN
                            <>
                                <TextRight maxWidth={1.8} fontsOw={fonts.cm.title} fontSize={0.16} positionY={-0.25} scale={1} exposant={"st"} offsetX={-1.428} offsetY={0.02}>
                                    1   plant-based cosmetic active ingredient
                                </TextRight>
                                <TextRight maxWidth={1.8} lineHeight={1.6} fontsOw={fonts.ms.text} exposantHeight={0.04} fontSize={0.062} positionY={-0.55} exposant={"®"} offsetX={-1.41} offsetY={-0.36}>
                                    TENSINE   , derived from wheat, is the first phytotensor active ingredient marketed by SILAB.
                                </TextRight>
                            </>
                        )
                    }
                </group>

                <group position={[0, -1.1, 0]}>
                    <TextRight
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.26}
                        positionY={0}
                        // positionX={-0.09}
                        // positionZ={1.2}
                        fontsOw={fonts.ms.title}
                    >
                        1994
                    </TextRight>
                    {
                        __(
                            // FR
                            <>
                                <TextRight maxWidth={2} fontsOw={fonts.cm.title} fontSize={0.16} positionY={-0.1} scale={1} exposant={"er"} offsetX={-1.67} offsetY={0.038}>
                                    1   actif issu d’un co-produit
                                </TextRight>
                                <TextRight maxWidth={1.5} lineHeight={1.6} fontsOw={fonts.ms.text} exposantHeight={0.04} fontSize={0.062} positionY={-0.57} exposant={"®"} offsetX={-1.018} offsetY={-0.182}>
                                    AMANDULINE   SG est le premier actif issu d’un co-produit, le tourteau d’amande douce, qui peut être utilisé dans tout soin capillaire pour les cheveux abîmés.
                                </TextRight>
                            </>
                            ,
                            // EN
                            <>
                                <TextRight maxWidth={2} fontsOw={fonts.cm.title} fontSize={0.16} positionY={-0.25} scale={1} exposant={"st"} offsetX={-1.66} offsetY={0.02}>
                                    1   active ingredient derived from a co-product
                                </TextRight>
                                <TextRight maxWidth={1.8} lineHeight={1.6} fontsOw={fonts.ms.text} exposantHeight={0.04} fontSize={0.062} positionY={-0.65} exposant={"®"} offsetX={-1.25} offsetY={-0.36}>
                                    AMANDULINE    SG is the first active ingredient derived from a co-product, sweet almond cake, which can be used in any hair care product for damaged hair.
                                </TextRight>
                            </>
                        )
                    }
                </group>

                <group position={[0, -2.75, 0]}>
                    <Float
                        speed={0.2}
                        rotationIntensity={0.5}
                        floatIntensity={0.1}
                        floatingRange={[-0.1, 0.1]}
                    >
                        <Tensine ref={tensineRef} scale={0.034} position={[1.3, 0, 3]} />
                    </Float>
                    <TextLeft
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.26}
                        positionY={0.35}
                        fontsOw={fonts.ms.title}
                    >
                        1995
                    </TextLeft>

                    {
                        __(
                            // FR
                            <>
                                <TextLeft
                                    maxWidth={4.2}
                                    lineHeight={1.4}
                                    fontSize={0.16}
                                    positionY={0}
                                    fontsOw={fonts.cm.title}
                                    exposant={'er'}
                                    offsetX={0.05}
                                    offsetY={-0.03}
                                >
                                    1   actif composé de peptides
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1.6}
                                    fontSize={0.062}
                                    positionY={-0.26}
                                    fontsOw={fonts.ms.text}
                                    exposant={'®'}
                                    exposantHeight={0.04}
                                    offsetX={0.46}
                                    offsetY={-0.569}
                                >
                                    Depuis sa création, SILAB extrait des peptides issus de diverses matières premières naturelles contenant des protéines pouvant être hydrolysées. Ces recherches ont conduit au lancement de STRUCTURINE   , un actif naturel issu du lupin blanc doux, riche en peptides glutaminés et en oligosaccharides.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4.2}
                                    lineHeight={1.4}
                                    fontSize={0.16}
                                    positionY={0}
                                    fontsOw={fonts.cm.title}
                                    exposant={'st'}
                                    offsetX={0.05}
                                    offsetY={-0.03}
                                >
                                    1  active ingredient composed of peptides
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1.6}
                                    fontSize={0.062}
                                    positionY={-0.25}
                                    fontsOw={fonts.ms.text}
                                    exposant={'®'}
                                    exposantHeight={0.04}
                                    offsetX={1.479}
                                    offsetY={-0.451}
                                >
                                    Since its creation, SILAB has been extracting peptides from various natural raw materials containing proteins that can be hydrolyzed. This research has led to the launch of STRUCTURINE   , a natural active ingredient derived from sweet white lupin, rich in glutamined peptides and oligosaccharides.
                                </TextLeft>
                            </>

                        )
                    }


                </group>
                <group position={[0, -3.7, 0]}>
                    {
                        __(
                            // FR
                            <>
                                <TextLeft
                                    maxWidth={4.2}
                                    lineHeight={1.4}
                                    fontSize={0.16}
                                    positionY={0}
                                    fontsOw={fonts.cm.title}
                                    offsetX={0.05}
                                    offsetY={-0.03}
                                >
                                    Installation à Saint-Viance
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1.6}
                                    fontSize={0.062}
                                    positionY={-0.22}
                                    fontsOw={fonts.ms.text}

                                >
                                    à 15 minutes de Brive, pour faire face à une croissance exponentielle.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4.2}
                                    lineHeight={1.4}
                                    fontSize={0.16}
                                    positionY={0}
                                    fontsOw={fonts.cm.title}
                                    offsetX={0.05}
                                    offsetY={-0.03}
                                >
                                    Moving to Saint-Viance
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1.4}
                                    fontSize={0.062}
                                    positionY={-0.22}
                                    fontsOw={fonts.ms.text}

                                >
                                    15 minutes from Brive, to cope with exponential growth.
                                </TextLeft>
                            </>

                        )
                    }

                </group>

                <AtelierProduction scale={1} position={[-2.5, -5, 0.6]} />

                <group position={[0, -4.3, 0]}>
                    {
                        __(
                            // FR
                            <>
                                <TextRight
                                    maxWidth={2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    positionY={-0}
                                    exposant={"er"}
                                    offsetX={-1.425}
                                    offsetY={0.13}>
                                    1   atelier de production
                                </TextRight>
                                <TextRight
                                    maxWidth={1.5}
                                    lineHeight={1.6}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    positionY={-0.35}
                                    offsetX={0.355}
                                    offsetY={0.0}>
                                    à la fois complexe pour reproduire les procédés en voie aqueuse et très flexible en termes de volumes de production.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    positionY={-0}
                                    exposant={"st"}
                                    offsetX={-1.11}
                                    offsetY={0.13}>
                                    1   production unit
                                </TextRight>
                                <TextRight
                                    maxWidth={1.6}
                                    lineHeight={1.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    positionY={-0.32}
                                    offsetX={0.355}
                                    offsetY={0.0}>
                                    that is both complex enough to reproduce aqueous processes and highly flexible in terms of production volumes.
                                </TextRight>
                            </>
                        )
                    }

                </group>

                <group position={[0, -5.15, 0]}>
                    {
                        __(
                            // FR
                            <>
                                <TextRight
                                    maxWidth={1.7}
                                    fontsOw={fonts.cm.title}
                                    lineHeight={1}
                                    fontSize={0.16}
                                    positionY={0.}
                                    offsetX={-1.34}
                                    offsetY={0.13}>
                                    Déploiement de l’activité aux États-Unis
                                </TextRight>
                                <TextRight
                                    maxWidth={1.3}
                                    lineHeight={1.6}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    positionY={-0.25}
                                    offsetX={0.385}
                                    offsetY={0.0}>
                                    à travers une collaboration avec un distributeur américain.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={1.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    positionY={0}
                                    offsetX={-1.34}
                                    offsetY={0.13}>
                                    Expansion of business in the United States
                                </TextRight>
                                <TextRight
                                    maxWidth={1.3}
                                    lineHeight={1.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    positionY={-0.2}
                                    offsetX={0.355}
                                    offsetY={0.0}>
                                    through a collaboration with an American distributor.
                                </TextRight>
                            </>
                        )
                    }

                </group>


                <Team scale={0.6} position={[width * 0.23 - 1.2, -4.8, 2]}>
                    30
                </Team>



                <group position={[0, -6.5, 0]}>
                    <TextLeft
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.26}
                        positionY={0}
                        fontsOw={fonts.ms.title}
                    >
                        1997
                    </TextLeft>
                    {
                        __(
                            // FR
                            <>
                                <TextLeft
                                    maxWidth={4.2}
                                    lineHeight={1.4}
                                    fontSize={0.16}
                                    positionY={-0.35}
                                    fontsOw={fonts.cm.title}
                                >
                                    Implantation en Asie
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1.4}
                                    fontSize={0.062}
                                    positionY={-0.59}
                                    fontsOw={fonts.ms.text}
                                >
                                    Des partenariats avec des distributeurs japonais et sud-coréens débutent.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4.2}
                                    lineHeight={1.4}
                                    fontSize={0.16}
                                    positionY={-0.35}
                                    fontsOw={fonts.cm.title}
                                >
                                    Setting up in Asia
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1.4}
                                    fontSize={0.062}
                                    positionY={-0.57}
                                    fontsOw={fonts.ms.text}
                                >
                                    Partnerships with Japanese and South Korean distributors are beginning.
                                </TextLeft>
                            </>

                        )
                    }

                </group>

                <group position={[0, -7.5, 0]}>
                    <TextLeft
                        maxWidth={4.2}
                        lineHeight={1.4}
                        fontSize={0.26}
                        positionY={0}
                        fontsOw={fonts.ms.title}
                    >
                        1998
                    </TextLeft>
                    {
                        __(
                            // FR
                            <>
                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1}
                                    fontSize={0.16}
                                    positionY={-0.38}
                                    fontsOw={fonts.cm.title}
                                >
                                    Création du laboratoire d’études cliniques
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1.4}
                                    fontSize={0.062}
                                    positionY={-0.77}
                                    fontsOw={fonts.ms.text}
                                    exposant={'in vivo'}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    offsetX={1.168}
                                    offsetY={-0.77}
                                >
                                    SILAB ouvre son laboratoire d’études                dans lequel des volontaires testent l’efficacité des produits.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={2.2}
                                    lineHeight={1}
                                    fontSize={0.15}
                                    positionY={-0.38}
                                    fontsOw={fonts.cm.title}
                                >
                                    Creation of the clinical studies laboratory
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    lineHeight={1.4}
                                    fontSize={0.057}
                                    positionY={-0.74}
                                    fontsOw={fonts.ms.text}
                                    exposant={'in vivo'}
                                    exposantHeight={0.052}
                                    expFont={fonts.ms.italic}
                                    offsetX={0.465}
                                    offsetY={-0.7435}
                                >
                                    SILAB opens its              studies laboratory where volunteers test the products’ efficacy.
                                </TextLeft>
                            </>
                        )
                    }

                    <TestVivo position={[-1, 0, 0]} scale={1.4} />

                </group>
                <group position={[0, -3.5, 0]}>
                    <group position={[0, -5, 0]}>
                        <TextCenter
                            maxWidth={4.2}
                            fontSize={0.26}
                            positionY={-1.5}
                            positionZ={.5}
                            fontsOw={fonts.ms.title}
                            depthWrite={false}
                        >
                            1999
                        </TextCenter>
                        <group position={[0, -1.7, 0]}>

                            {
                                __(
                                    //FR
                                    <>
                                        <TextCenter
                                            maxWidth={4}
                                            fontsOw={fonts.cm.title}
                                            fontSize={0.16}
                                            exposantHeight={0.07}
                                            positionY={-.2}
                                            positionZ={.5}
                                            scale={1}
                                            exposant={"er"}
                                            offsetX={-0.82}
                                            offsetY={-0.19}>
                                            1  actif d’origine biotechnologique
                                        </TextCenter>

                                        <TextCenter
                                            maxWidth={2}
                                            fontsOw={fonts.cm.text}
                                            fontSize={0.062}
                                            lineHeight={1.4}
                                            exposantHeight={0.05}
                                            positionY={-.4}
                                            positionZ={.5}
                                            scale={1}
                                            exposant={"®"}
                                            offsetX={-0.47}
                                            offsetY={-0.4}>
                                            TONISKIN   , extrait et purifié à partir d’une levure, diminue les rides, lisse le microrelief et redessine harmonieusement les contours du visage.
                                        </TextCenter>
                                    </>,
                                    //EN
                                    <>
                                        <TextCenter
                                            maxWidth={4}
                                            fontsOw={fonts.cm.title}
                                            fontSize={0.16}
                                            exposantHeight={0.07}
                                            positionY={-.2}
                                            positionZ={.5}
                                            scale={1}
                                            exposant={"st"}
                                            offsetX={-1.13}
                                            offsetY={-0.19}>
                                            1   active ingredient of biotechnological origin
                                        </TextCenter>

                                        <TextCenter
                                            maxWidth={2}
                                            fontsOw={fonts.cm.text}
                                            fontSize={0.062}
                                            lineHeight={1.4}
                                            exposantHeight={0.05}
                                            positionY={-.4}
                                            positionZ={.5}
                                            scale={1}
                                            exposant={"®"}
                                            offsetX={-0.46}
                                            offsetY={-0.4}>
                                            TONISKIN   , extracted and purified from a yeast, reduces wrinkles, smooths microrelief and harmoniously redesigns facial contours.
                                        </TextCenter>
                                    </>
                                )
                            }



                        </group>
                    </group>
                    <group position={[0, -6, 0]}>
                        <Levures
                            scale={1}
                            position={[0.1, -1, 2]}
                        />
                    </group>
                </group>

            </group>
        </group>

    </>
}